// @mui
import { mapVisitPaymentStatusToString } from 'src/utils/mapVisitPaymentStatusToString';
import { PaymentStatusEnum } from 'woofwoof-api';
import Iconify from '../iconify';
import Label from '../label';
// ----------------------------------------------------------------------

interface VisitPaymentStatusBadgeProps {
  paymentStatus?: PaymentStatusEnum;
}

export default function VisitPaymentStatusBadge({
  paymentStatus,
}: VisitPaymentStatusBadgeProps) {
  if (!paymentStatus) {
    return null;
  }

  const statusInfo = mapVisitPaymentStatusToString(paymentStatus);

  if (!statusInfo) {
    return null;
  }

  return (
    <Label
      variant="soft"
      color={statusInfo.color}
      sx={{ textTransform: 'none', width: 'fit-content' }}
      startIcon={<Iconify icon={statusInfo.icon || ''} />}
    >
      {statusInfo.label}
    </Label>
  );
}
